import type { GanttFornecedorProps } from "./types-gantt-fornecedor";
import { useGanttFornecedor } from "./use-gantt-fornecedor";
import { GanttFornecedorView } from "./view-gantt-fornecedor";

export function GanttFornecedor(props: GanttFornecedorProps) {
  const vm = useGanttFornecedor(props);

  return <GanttFornecedorView {...vm} />;
}

export type * from "./types-gantt-fornecedor";
